import { AiSaasOutputProvider, useAiSaasOutputContainer } from "..";
import AISaasOutpuItem from "../Item";
import css from "./index.module.scss";
import classNames from "classnames";
import { closestCenter, DndContext } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import AISaasItemContent from "../ItemContent";

function AiSaasOutputList() {
  const { dndThoughts, className, sensors, onDragStart, onDragEnd, modifiers } = useAiSaasOutputContainer();

  return (
    <DndContext
      sensors={sensors}
      modifiers={modifiers}
      collisionDetection={closestCenter}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      autoScroll
    >
      <div className={classNames(css["AiSaasOutputList"], className)}>
        <SortableContext items={dndThoughts} strategy={verticalListSortingStrategy}>
          {dndThoughts.map(groupThought => (
            <AISaasOutpuItem key={groupThought.id} id={groupThought.id}>
              <div className={css["groupThought"]}>
                {/* <AISaasItemContent key={groupThought.id} thought={groupThought} index={index} /> */}

                {/* group */}
                {groupThought.groupDnd.map((thought, index) => (
                  <AISaasItemContent key={thought.id} thought={thought} index={index} />
                ))}
              </div>
            </AISaasOutpuItem>
          ))}
        </SortableContext>
        {/* <DragOverlay>{activeId ? <AISaasActive /> : null}</DragOverlay> */}
      </div>
    </DndContext>
  );
}

export default function AiSaasOutputListWrap(props: AISaasOutput.AiSaasOutputListProps) {
  return (
    <AiSaasOutputProvider initialState={props}>
      <AiSaasOutputList />
    </AiSaasOutputProvider>
  );
}
